import React from 'react'
import { Link } from 'react-router-dom'

const Breadcrumb = ({ title, bg }) => {
    return (
        <div className="breadcumb-wrapper" style={{ backgroundImage: `url('${ bg}')`}}>
            {/* bg animated image/ */}
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-10">
                        <div className="breadcumb-content">
                            <h1 className="breadcumb-title">{title}</h1>
                            <ul className="breadcumb-menu ">
                                <li>
                                    <Link className='text-white' to="/">Home</Link>
                                </li>
                                <li className="active text-white">{title}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Breadcrumb